/**
 * Staggered fade/slide-in for detail panels (ViewPAF, User Management modal, etc.).
 * @param {boolean} reducedMotion
 * @returns {(delay?: number) => object}
 */
export function createTextMotionProps(reducedMotion) {
  return (delay = 0) => ({
    initial: reducedMotion ? false : { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    transition: {
      delay: reducedMotion ? 0 : 0.5 + delay,
      duration: reducedMotion ? 0 : 0.35,
      ease: [0.22, 1, 0.36, 1],
    },
  });
}
